import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    getList: {
        url: `${customerApi}/api/channel_welcome_messages`,
        type: 'GET',
    },

    editUser: {
        url: `${customerApi}/api/channel_welcome_messages`,
        type: 'POST',
    },
}
